import CompanyFollowers from "../../components/companyFollowers/CompanyFollowers"

function CompanyFollowersPage() {
    return (
        <>
        <CompanyFollowers/>
        </>
    )
}
export default CompanyFollowersPage